import { callDataFetcherTraced } from './wrapperUtils.js';

/**
 * Create a wrapped version of the user's exported `getInitialProps` function
 *
 * @param origGetInitialProps The user's `getInitialProps` function
 * @param parameterizedRoute The page's parameterized route
 * @returns A wrapped version of the function
 */
function withSentryGetInitialProps(
  origGetInitialProps,
  parameterizedRoute,
) {
  return async function (
    ...getInitialPropsArguments
  ) {
    return callDataFetcherTraced(origGetInitialProps, getInitialPropsArguments, {
      parameterizedRoute,
      dataFetchingMethodName: 'getInitialProps',
    });
  };
}

export { withSentryGetInitialProps };
//# sourceMappingURL=withSentryGetInitialProps.js.map
